module.exports = __webpack_public_path__ + "static/media/206-corporate-events.5482fa55.jpg";